import script from "./SharePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./SharePopup.vue?vue&type=script&setup=true&lang=js"

import "./SharePopup.vue?vue&type=style&index=0&id=2c3fa9d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c3fa9d8"]])

export default __exports__